let Balboa = require("ES/services/Balboa");
let RadioService = require("ES/lib/react-pubsub-via-radio.js/service");

module.exports.init = function(){
	RadioService("EventServices_computeAndAddRoyalties", function(params, callback){
		Balboa.api("/eventservices/computeandaddroyalties/" + params.eid, {
			clear_old_royalties: !!params.clear_old_royalties
		}, function(data){
			callback(null, data.message);
		}, function(data){
			callback((data && data.message) || "unknown cause");
		});
	});

	RadioService("EventServices_computeFamilyValues", function(params, callback){
		Balboa.api("/eventservices/computefamilyvalues/" + params.eid, params, function(data){
			callback(null, data.message);
		}, function(data){
			callback((data && data.message) || "unknown cause");
		});
	});
};



// WEBPACK FOOTER //
// ./src/services/EventServices.js